module.exports = __webpack_public_path__ + "assets/img/prof-registration.png";